// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-search-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimExportButton/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".export-search-button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
